import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/JobReasons/Filter'

export default createListViewComponent({
  entityName: entityNames.jobReasons,
  createButtonTextId: 'createJobReason',
  primaryLinkTarget: 'jobReasonRecord',
})(Filter)
